export const SHOWCASE_MODELS = 0
export const CELLULAR_MODELS = 1
export const NON_CELLULAR_MODELS = 2
